import LinksGridSection from 'components/BaseHelpers/LinksGridSection';

import { ComponentProps } from '../../../types/component-props';
import { CoreRelatedPracticesData } from '../../../types/components';

export type CoreRelatedPracticesProps = ComponentProps & CoreRelatedPracticesData;

const CoreRelatedPractices = (props: CoreRelatedPracticesProps): JSX.Element => {
  const { heading, description, links, displayCount, showAllLabel, jumpLinkLabel } = props.fields;

  if (links.length === 0) {
    return <></>;
  }

  return (
    <LinksGridSection
      heading={heading}
      description={description}
      links={links}
      displayCount={displayCount}
      showAllLabel={showAllLabel}
      jumpLinkLabel={jumpLinkLabel}
    />
  );
};

export default CoreRelatedPractices;
